// extracted by mini-css-extract-plugin
export default {"settingDrawer":"styleModule_settingDrawer__59zue","settingSelection":"styleModule_settingSelection__-8QMG","changeBackground":"styleModule_changeBackground__vTDPX"};